import { Image } from '@mantine/core';
import { ChatConversationTile } from '@/src/shared/components/chat/chat-conversation-tile';
import { useMarketplaceCustomerChatContext } from '../../../_contexts';

export function ChatFloatingWindowComplaintConversationTile() {
  const {
    complaintConversation,
    selectedConversationId,
    setSelectedConversationId,
  } = useMarketplaceCustomerChatContext();
  const complaintConversationIsSelected =
    selectedConversationId === complaintConversation?.props.id;

  return (
    <ChatConversationTile
      size="sm"
      conversation={complaintConversation!}
      overrideName="Chat Pengaduan"
      isSelected={complaintConversationIsSelected}
      onClick={() => setSelectedConversationId(complaintConversation!.props.id)}
      avatar={
        <Image
          w="2rem"
          h="2rem"
          src="/images/customer-service.png"
          alt="Chat Pengaduan"
          className="object-contain!"
          bg="white"
          bdrs={999}
        />
      }
      showLastMessage={false}
    />
  );
}
